import React, { useEffect } from "react";
import { useUser } from "../../hooks/queries/useUser";
import useAuth from "@/hooks/stores/useAuth";
import { useNavigate } from "react-router-dom";
import { Form } from "../Users/Form";
import { User_Dashboard } from "../Users/User_Dashboard";
import { LegalAdvisorDashboard } from "../Users/LegalAdvisorDashboard";

export function Dashboard() {
  const { userRole } = useAuth();
  const navigate = useNavigate();
  // if (isLoading) return <div>Loading...</div>;
  // if (error) return <div>Error: {error.message}</div>;

  useEffect(() => {
    if (userRole?.toLowerCase() === 'reporting') {
      navigate('/reports');
    }
  }, [userRole, navigate]);

  return (
    // p-4
    <div className="mx-auto  ">
      {/* <h1 className="mb-4 mt-5 font-bold text-2xl text-center text-foreground">Welcome to the Home Page</h1> */}

      {userRole?.toLowerCase() === 'admin' && (
        <div>
          {/* <AdminDashboard /> */}
          <h1 className="pt-10 text-2xl font-bold text-center text-foreground">Admin Dashboard</h1>
        </div>
      )}
      {userRole?.toLowerCase() === 'legal advisor' && (
          <div>
            <LegalAdvisorDashboard />
          </div>
        )
      }
      {userRole?.toLowerCase() === 'head of department' && (
        <div>
          {/* <HodDashboard /> */}
          <h1 className="pt-10 text-2xl font-bold text-center text-foreground">Head of Department Dashboard</h1>
        </div>
      )}
      {
        userRole?.toLowerCase() === 'user' && (
          <div>
            <User_Dashboard />
          </div>
        )
      }
       
       {(userRole?.toLowerCase() === 'manager' || userRole?.toLowerCase() === 'bereavement team') && (
        <div>
          {/* <HodDashboard /> */}
          <h1 className="pt-10 text-2xl font-bold text-center text-foreground">{userRole?.toLowerCase() === 'manager' ? 'Manager' : 'Bereavement Team'} Dashboard</h1>
        </div>
      )}
    </div>
  );
}
